<template>
	<transition mode="out-in" v-bind="{ name }">
		<slot />
	</transition>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
	props: {
		silent: {
			type: Boolean,
		},
	},

	computed: {
		name(): string {
			return this.silent ? 'non-existing' : 'fade';
		},
	},
});
</script>

<style lang="scss">
.fade {
	&-enter-active,
	&-leave-active {
		transition: opacity 0.25s $easeOutQuart;
	}

	&-enter-from,
	&-leave-to {
		opacity: 0;
	}
}
</style>
